import { isEmptyString } from '@/utils/util';

export const validateMaxItems = (
  value: string | number | undefined,
  defaultValue?: number,
): number | undefined => {
  if (isEmptyString(value)) return defaultValue;
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) {
    console.error('max_items is not a number');
    return undefined;
  }
  return numberValue;
};
